import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { ErrorHandler } from '@helper/errorHandler';
import { FccCheckPayload } from '.';

export const useFccCheckQuery = (membershipId: number): IQueryResponse<FccCheckPayload> => {
	const fetchFccData = async (): Promise<FccCheckPayload> => {
		try {
			const url = `${APICONFIG.FCC_CHECKS_FPC_USER}`;
			return await APIService.getData<FccCheckPayload>(url, {
				membership_no: `${membershipId}`,
			});
		} catch (error) {
			ErrorHandler(error);
			throw error;
		}
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['fccCheck'],
		queryFn: fetchFccData,
		enabled: !!membershipId,
		refetchOnWindowFocus: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
